import React from "react";
import About from "../../component/landingpage/about_us/About";
import Footer from "../../component/landingpage/footer/Footer";
import TopNav from "../../component/landingpage/header/TopNav";
import Hero from "../../component/landingpage/hero/Hero";
import Infographics from "../../component/landingpage/infograph/Infographics";
import ServiceBilling from "../../component/landingpage/servicebilling/ServiceBilling";
import Testimonial from "../../component/landingpage/testimonials/Testimonial";
import "./Home.scss";

const Home = () => {
  return (
    <div className="homie">
      <TopNav />
      <Hero />
      <About />
      <Infographics />
      <ServiceBilling />
      <Testimonial />
      <Footer />
    </div>
  );
};

export default Home;
